import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const n = r((e, l) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: l,
    ...e,
    image: (a) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M1 2v2.5C1 10.299 5.701 15 11.5 15H14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3.586a1 1 0 0 0-.707.293l-1.376 1.376c-.212.212-.546.116-.759-.097L4.428 8.428c-.213-.213-.31-.547-.097-.76l1.376-1.375A1 1 0 0 0 6 5.586V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
n.displayName = "PhoneIcon";
export {
  n as PhoneIcon,
  n as default
};
//# sourceMappingURL=index.js.map
